<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
};
</script>

<style>
  /* Import Google Font (Poppins) */
  @import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;700&display=swap');

  /* Si quieres mantener Roboto también */


  /* Aplica Poppins como fuente general */
  body {
    font-family: 'Comfortaa', 'Poppins', 'Roboto', sans-serif;
  }

  /* Fondo azul muy clarito global */
  html, body, #app {
    background-color: #f0f4fa;
  }

  /* Estilo específico del footer */
  .footer {
    background-image: linear-gradient(19deg, #294697 0%, #1D3C7F 100%);
    font-family: 'Poppins', sans-serif; /* opcional si ya aplicaste en body */
  }

  /* Loader v-sync: centrado en el viewport (clase compartida por los dashboards) */
  .spinner-centrado {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  /* Keyframes del loader v-sync: nombre exacto que referencian los inline styles */
  @keyframes v-syncStretchDelay {
    33% { transform: translateY(10px); }
    66% { transform: translateY(-10px); }
    100% { transform: translateY(0); }
  }

  /* Suavizar encabezados de tablas Vuetify: evitar negrillas pesadas y sombreados oscuros */
  .theme--light.v-data-table .v-data-table-header th {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.65) !important;
  }

  .theme--light.v-data-table .v-data-table-header th.active,
  .theme--light.v-data-table .v-data-table-header th.sortable.active {
    color: rgba(0, 0, 0, 0.75) !important;
    font-weight: 600 !important;
    background-color: transparent !important;
  }

  .theme--light.v-data-table .v-data-table-header th .v-data-table-header__icon {
    color: rgba(0, 0, 0, 0.45) !important;
  }
</style>
